import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { api } from "api";
import { Children } from "api/types";
import { ComponentProps } from "components/Loader";
import React, { useCallback, useEffect } from "react";
import { IndivResultPage } from "./IndividualResultPage";

export const ParentResult = ({ setLoading }: ComponentProps): JSX.Element => {
	const [child, setChild] = React.useState("");
	const [childId, setChildId] = React.useState("");
	const [children, setChildren] = React.useState<Children[]>([]);
	// const [childrenList, setChildList] = React.useState("");
	const handleChange = (event: SelectChangeEvent): void => {
		setChild(event.target.value);
		setLoading(true);
	};

	const generateMenu = (): React.ReactElement[] => {
		return children.map((a) => {
			return (
				<MenuItem
					onClick={() => setChildId(a.id)}
					key={a.id}
					value={a.firstname}
				>
					{a.firstname}
				</MenuItem>
			);
		});
	};

	const fetchChildren = useCallback(() => {
		if (window.sessionStorage.getItem("children-result") === null) {
			api
				.GetChildren()
				.then((res) => {
					if (res.status !== 200) {
						throw new Error();
					}
					window.sessionStorage.setItem(
						"children-result",
						JSON.stringify(res.data),
					);
					setChildren(res.data);
					if (res.data[0] !== undefined) {
						setChild(res.data[0].firstname);
						setChildId(res.data[0].id);
					}
					// eslint-disable-next-line @typescript-eslint/no-unsafe-return
					return res.data;
				})
				.catch(() => {});
		} else {
			const Storage = window.sessionStorage.getItem("children-result");
			if (Storage !== null) {
				const childrenArray = JSON.parse(Storage);
				setChildren(childrenArray);
				if (childrenArray[0] !== undefined) {
					setChild(childrenArray[0].firstname);
					setChildId(childrenArray[0].id);
				}
			}
		}
	}, []);

	useEffect(() => {
		fetchChildren();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Grid container spacing={2}>
			<Grid item xs={10}>
				<Typography variant="h2" data-testid="hello">
					{child} - Result
				</Typography>
			</Grid>

			<Grid item xs={2}>
				<FormControl sx={{ m: 1, minWidth: 120 }}>
					<Select value={child} onChange={handleChange} displayEmpty>
						{generateMenu()}
					</Select>
					{/* <FormHelperText>Without label</FormHelperText> */}
				</FormControl>
			</Grid>
			<IndivResultPage setLoading={setLoading} uuid={childId} />
		</Grid>
	);
};
